module.exports = __webpack_public_path__ + "static/img/co-operate-03.97437b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/co-operate-03.png
// module id = VyrQ
// module chunks = 1